import isObject from '@commons/utils/object/isObject';

export const pick = (fromObject, properties = []) =>
  fromObject &&
  properties.reduce((p, c) => {
    if (Object.prototype.hasOwnProperty.call(fromObject, c)) {
      // eslint-disable-next-line no-param-reassign
      p[c] = fromObject[c];
    }
    return p;
  }, {});

export function pickWithNoUndefinedValues(fromObject, properties = []) {
  return (
    fromObject &&
    Object.keys(fromObject).reduce((acc, k) => {
      if (properties.includes(k) && fromObject[k] !== undefined) {
        acc[k] = fromObject[k];
      }
      return acc;
    }, {})
  );
}

export function getNestedObject(nestedObj, pathArr, defaultValue) {
  return pathArr.reduce(
    (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : defaultValue),
    nestedObj,
  );
}

export function ignore(map = {}, propsToFilter = []) {
  return Object.keys(map).reduce((acc, key) => {
    if (propsToFilter.indexOf(key) === -1) acc[key] = map[key];
    return acc;
  }, {});
}

export function iteratorToObject(it) {
  return [...it].reduce((acc, param) => {
    const [key, value] = param;
    acc[key] = value;
    return acc;
  }, {});
}

export function objectToQuery(obj) {
  return Object.keys(obj).reduce((q, k, i) => {
    if (i === 0) return `${k}=${obj[k]}`;
    return `${q}&${k}=${obj[k]}`;
  }, '');
}

export function isNullOrUndefined(o) {
  return o === null || o === undefined;
}

export function hasValue(o) {
  return !isNullOrUndefined(o) && o !== '';
}

export function updateKeys(targetObject, obj) {
  const result = Object.assign({}, targetObject);

  Object.keys(obj).forEach(key => {
    /* Update only existing keys */
    if (result[key]) {
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        // target property not object, overwrite with empty object
        if (!(typeof result[key] === 'object' && !Array.isArray(result[key]))) {
          result[key] = {};
        }

        /* recursive if needed */
        result[key] = updateKeys(result[key], obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  });
  return result;
}

export function toCamel(str) {
  return str.replace(/([-_][a-z])/gi, $1 =>
    $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', ''),
  );
}

export function keysToCamel(obj) {
  if (isObject(obj)) {
    const newObject = {};

    Object.keys(obj).forEach(k => {
      newObject[toCamel(k)] = keysToCamel(obj[k]);
    });

    return newObject;
  }

  return obj;
}

export default {
  pick,
  ignore,
  iteratorToObject,
  isNullOrUndefined,
  keysToCamel,
};
